var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Breadcrumbs"},[_c('div',{staticClass:"Breadcrumbs1"},[_vm._v(" "+_vm._s(_vm.BreData.BreData1)+" ")]),_vm._m(0),_c('div',{staticClass:"Breadcrumbs3"},[_vm._v(" "+_vm._s(_vm.BreData.BreData2)+" ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Breadcrumbs2"},[_c('i',{staticClass:"el-icon-arrow-right"})])
}]

export { render, staticRenderFns }